import { connect } from 'react-redux'
import ExportApiConfig from './ExportApiConfig.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    agentId: state.agent?.active?.agentId,
    storageType: state.analyticsExport.exportApiConfig.storageType,
    isFetching: state.analyticsExport.isFetchingExportApiConfig,
    isSaving: state.analyticsExport.isSavingExportApiConfig
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateExportApiConfig: key => e => dispatch(Actions.updateExportApiConfig(key, e.target.value)),
    fetchExportApiConfig: () => dispatch(Actions.fetchExportApiConfig())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportApiConfig)
